export type { VacancyPageProps } from "./vacancy-page";
export { VacancyPage } from "./vacancy-page";
